import {
  Box,
  CircularProgress,
  Container,
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography,
} from "@mui/material"
import { StyledButton } from "components/Button/StyledButton"
import { useEffect, useState } from "react"
import { useStoreActions, useStoreState } from "../../hooks/storeHooks"

export const UsersPage = () => {
  const { fetchUsers } = useStoreActions((actions) => actions)
  const { users } = useStoreState((state) => state)

  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const loadContacts = async () => {
      try {
        setLoading(true)
        setError(null)
        await fetchUsers({ fresh: false })
      } catch (err) {
        console.error("Error loading contacts:", err)
        setError(
          "Fehler beim Laden der Kontakte. Bitte versuchen Sie es später erneut."
        )
      } finally {
        setLoading(false)
      }
    }

    loadContacts()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleRetry = async () => {
    try {
      setLoading(true)
      setError(null)
      await fetchUsers({ fresh: true })
    } catch (err) {
      console.error("Error reloading contacts:", err)
      setError(
        "Fehler beim Laden der Kontakte. Bitte versuchen Sie es später erneut."
      )
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "50vh",
        }}
      >
        <CircularProgress />
      </Box>
    )
  }

  if (error) {
    return (
      <Box sx={{ textAlign: "center", py: 4 }}>
        <Typography color="error" variant="h6">
          {error}
        </Typography>
        <StyledButton
          onClick={handleRetry}
          sx={{ mt: 2 }}
        >
          Retry
        </StyledButton>
      </Box>
    )
  }

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Paper elevation={3} sx={{ p: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Azure AD Users
        </Typography>
        {users.length === 0 ? (
          <Typography>Keine Benutzer gefunden oder lädt noch...</Typography>
        ) : (
          <List>
            {users.map((user) => (
              <ListItem key={user.id} divider>
                <ListItemText
                  primary={user.displayName || "N/A"}
                  secondary={
                    <>
                      Email: {user.email || user.userPrincipalName || "N/A"}
                      <br />
                      ID: {user.id}
                    </>
                  }
                />
              </ListItem>
            ))}
          </List>
        )}
      </Paper>
    </Container>
  )
}
